// material-ui
import { useTheme } from '@mui/material/styles';

// ==============================|| LOGO ICON SVG ||============================== //

export default function LogoIcon() {
  const theme = useTheme();

  return (
    <svg width="129" height="129" viewBox="28 42 163 163" fill="none" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <linearGradient id="li-gradTop" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor={theme.palette.primary.light} />
          <stop offset="100%" stopColor={theme.palette.primary.main} />
        </linearGradient>
        <linearGradient id="li-gradSide" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor={theme.palette.primary.main} />
          <stop offset="100%" stopColor={theme.palette.primary.darker} />
        </linearGradient>
        <filter id="li-shadow" x="-50%" y="-50%" width="200%" height="200%">
          <feDropShadow dx="0" dy="6" stdDeviation="6" floodOpacity="0.25" />
        </filter>
      </defs>

      {/* Sombra base */}
      <ellipse cx="110" cy="185" rx="60" ry="12" fill="#000" opacity="0.15" />

      {/* Panel 4 (más bajo) */}
      <g transform="translate(0, 36)">
        <polygon points="60,100 110,80 160,100 110,120" fill="url(#li-gradTop)" />
        <polygon points="60,100 60,120 110,140 110,120" fill="url(#li-gradSide)" />
        <polygon points="160,100 160,120 110,140 110,120" fill={theme.palette.primary.dark} />
        <circle cx="65" cy="100" r="3" fill={theme.palette.info.main} />
        <circle cx="155" cy="100" r="3" fill={theme.palette.info.main} />
        <circle cx="65" cy="120" r="3" fill={theme.palette.info.light} />
        <circle cx="155" cy="120" r="3" fill={theme.palette.info.light} />
      </g>

      {/* Panel 3 */}
      <g transform="translate(0, 24)">
        <polygon points="60,90 110,70 160,90 110,110" fill="url(#li-gradTop)" />
        <polygon points="60,90 60,110 110,130 110,110" fill="url(#li-gradSide)" />
        <polygon points="160,90 160,110 110,130 110,110" fill={theme.palette.primary.dark} />
        <circle cx="65" cy="90" r="3" fill={theme.palette.info.main} />
        <circle cx="155" cy="90" r="3" fill={theme.palette.info.main} />
        <circle cx="65" cy="110" r="3" fill={theme.palette.info.light} />
        <circle cx="155" cy="110" r="3" fill={theme.palette.info.light} />
      </g>

      {/* Panel 2 */}
      <g transform="translate(0, 12)">
        <polygon points="60,80 110,60 160,80 110,100" fill="url(#li-gradTop)" />
        <polygon points="60,80 60,100 110,120 110,100" fill="url(#li-gradSide)" />
        <polygon points="160,80 160,100 110,120 110,100" fill={theme.palette.primary.dark} />
        <circle cx="65" cy="80" r="3" fill={theme.palette.info.main} />
        <circle cx="155" cy="80" r="3" fill={theme.palette.info.main} />
        <circle cx="65" cy="100" r="3" fill={theme.palette.info.light} />
        <circle cx="155" cy="100" r="3" fill={theme.palette.info.light} />
      </g>

      {/* Panel superior */}
      <g filter="url(#li-shadow)">
        <polygon points="60,70 110,50 160,70 110,90" fill="url(#li-gradTop)" />
        <polygon points="60,70 60,90 110,110 110,90" fill="url(#li-gradSide)" />
        <polygon points="160,70 160,90 110,110 110,90" fill={theme.palette.primary.dark} />
        <circle cx="65" cy="70" r="3" fill={theme.palette.info.main} />
        <circle cx="155" cy="70" r="3" fill={theme.palette.info.main} />
        <circle cx="65" cy="90" r="3" fill={theme.palette.info.light} />
        <circle cx="155" cy="90" r="3" fill={theme.palette.info.light} />
      </g>
    </svg>
  );
}
